import React from "react";
import { FormattedMessage } from "react-intl";

import { CommonModalHeader, ModalDialog } from "../../../../components/modal";
import { Button } from "../../../../components/button/Button";
import { DeviceCreationFlowSelector } from "./supportingComponents/supportingComponents/DeviceCreationFlowSelector";

import "./AddDeviceDialog.scss";

export const AddDeviceDialog = ({ modal, currentProfile }) => {
  const close = () => modal.reject();

  return (
    <ModalDialog className={"add-device-modal"} rejectHandler={close}>
      <CommonModalHeader>
        <FormattedMessage id="add_device" />
      </CommonModalHeader>
      <ModalDialog.Body>
        <DeviceCreationFlowSelector currentProfile={currentProfile} />
      </ModalDialog.Body>
      <ModalDialog.Footer>
        <ModalDialog.Control>
          <Button color={"secondary"} size={"large"} onClick={close}>
            <FormattedMessage id="close" />
          </Button>
        </ModalDialog.Control>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};
